import React from 'react';
import { useLocation } from 'react-router-dom';
import { I18nProvider } from './I18nContext';
import { getLocalizedRoute } from './localizedRoutes';

const RouteI18nProvider = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <I18nProvider routeLocale={getLocalizedRoute(pathname)?.locale}>
      {children}
    </I18nProvider>
  );
};

export default RouteI18nProvider;
